export default "__VITE_ASSET__7ac6c777__"